import React from 'react';

const PromotionBanner: React.FC = () => {
  return (
    <div className="bg-sale text-white text-center py-2 pulse-sale">
      <div className="max-w-7xl mx-auto px-4">
        <p className="font-semibold">
          Premium pergolas: standard installation and delivery included · Premium+ by individual quote
        </p>
      </div>
    </div>
  );
};

export default PromotionBanner;
